export default __webpack_public_path__ + "static/media/whitepaper.127f7261.svg";